import React from 'react';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { SessionServerSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { useSelector } from '~src/settings/general-settings/utils';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const CLOUD_GUEST_ACCESS_FIELD = 'settings.guestAccessEnabled';
export const CLOUD_GUEST_ACCESS_SECTION_TEST_ID = 'cloud-guest-access-site-setting';
export const CLOUD_GUEST_ACCESS_CHECKBOX_TEST_ID = 'cloud-guest-access-enabled';

export type CloudGuestAccessSectionProps = SiteSettingsForSiteAdminProps<'guestAccessEnabled'>;

export function CloudGuestAccessSection(props: CloudGuestAccessSectionProps) {

  return !useShowSettingsSection() ? null : (
    <SettingsSection title={Messages.guestAccess()}
      testId={CLOUD_GUEST_ACCESS_SECTION_TEST_ID}>

      <FormikCheckbox name={CLOUD_GUEST_ACCESS_FIELD}
        label={Messages.guestControlLabelForSite()}
        testId={CLOUD_GUEST_ACCESS_CHECKBOX_TEST_ID}>
      </FormikCheckbox>
    </SettingsSection>
  );
}

function useShowSettingsSection(): boolean {
  const isOnlineEnvironment = useSelector(SessionServerSelectors.isOnlineEnvironment);
  return FeatureFlags.cloudGuestAccessEnabled && isOnlineEnvironment;
}

export const CloudGuestAccessSectionSpecs = componentRegistryEntry({
  name: 'CloudGuestAccessSection',
  component: CloudGuestAccessSection
});
